import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CreateWhiteboardMutation: GraphQLTaggedNode = graphql`
	mutation CreateWhiteboardMutation(
		$spaceKey: String!
		$parentId: ID
		$contentSpecificCreateInput: [ContentSpecificCreateInput!]
		$title: String
	) {
		createContentContextual(
			input: {
				spaceKey: $spaceKey
				parentId: $parentId
				contentSpecificCreateInput: $contentSpecificCreateInput
				status: CURRENT
				type: "whiteboard"
				title: $title
			}
		) {
			id
			space {
				id
				key
				alias
			}
		}
	}
`;
